import ImageNotFound from '@/assets/images/404/404.svg';

export const ErrorBoundaryFallback = () => {
  return (
    <div className="container text-center min-h-40 flex items-center justify-center my-4 lg:my-8 fallback-container">
      <div className="space-y-4">
        <div className="w-[240px] relative md:w-[280px] lg:w-[380px] mx-auto flex items-center justify-center">
          <img
            className="w-full fallback-robot"
            src={ImageNotFound}
            alt="image not found"
            loading="lazy"
          />
        </div>
        <div className="space-y-2">
          <h2 className="uppercase text-2xl md:text-4xl lg:text-5xl text-black font-lateral1000 fallback-title">
            Oops! Something went wrong
          </h2>
          <p className="text-sm md:text-base lg:text-lg">
            We've been notified and are looking into the issue
          </p>
        </div>
      </div>
    </div>
  );
};
